import React, { useEffect, useState } from "react";
import Toast from "../../../base/components/Toast";
import { useTranslation } from "../../../i18n/LanguageContext";
import { generateEmailConfirmationCode } from "../authSlice";

const COOLDOWN_SECONDS = 30;

/**
 * "click here to resend it" on the verification pages: asks the API for a new e-mail
 * confirmation code, then waits COOLDOWN_SECONDS before it can be used again.
 */
function ResendCodeButton({ email }) {
   const { t } = useTranslation();
   const [sending, setSending] = useState(false);
   const [secondsLeft, setSecondsLeft] = useState(0);

   useEffect(() => {
      if (secondsLeft <= 0) return undefined;
      const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
      return () => clearTimeout(timer);
   }, [secondsLeft]);

   const resend = async () => {
      setSending(true);
      try {
         await generateEmailConfirmationCode(email);
         Toast.success(t("verification-code-sent-description"));
         setSecondsLeft(COOLDOWN_SECONDS);
      } catch (error) {
         const messages = error?.response?.data?.errors?.map((e) => e.message) ?? [];
         if (messages.length) {
            messages.forEach((message) => Toast.error(message));
         } else {
            Toast.error(t("unexpected-error-description"));
         }
      } finally {
         setSending(false);
      }
   };

   return (
      <button
         type="button"
         className="kap-org-verify__resend"
         onClick={resend}
         // Without an e-mail in the URL there's nothing to resend to.
         disabled={!email || sending || secondsLeft > 0}
      >
         {t("resend-code-link")}
         {secondsLeft > 0 && ` (${secondsLeft}s)`}
      </button>
   );
}

export default ResendCodeButton;
